// @todo: Migrate to 'Switch' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Switch} from '@wandb/weave/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import * as React from 'react';

import {LabeledOptionBlock as LabeledOption} from '../elements/LabeledOptionBlock';
import {type PanelConfig} from './types';

type AggregationToggleProps = {
  checked: boolean;
  disabled: boolean;
  updateConfig: (newConfig: PanelConfig) => void;
};
export const AggregationToggle = ({
  disabled,
  checked,
  updateConfig,
}: AggregationToggleProps) => {
  return (
    <Tailwind>
      <LabeledOption
        label="Windowing"
        helpText="Windowing aggregates data into sections along the x-axis, averaging points within each section. Without windowing, only points with the same x-axis value are averaged together."
        option={
          <Switch.Root
            data-test={'windowing-switch'}
            size="medium"
            name="Windowing switch"
            disabled={disabled}
            checked={checked}
            onCheckedChange={isChecked => updateConfig({windowing: isChecked})}>
            <Switch.Thumb size="medium" checked={checked ?? false} />
          </Switch.Root>
        }
      />
    </Tailwind>
  );
};
